module.exports = __webpack_public_path__ + "media/images/frontend/facebook-edc1a366d34e3214b7c00ecb19eab021.svg";